document.addEventListener( 'DOMContentLoaded', function () {
	const tocBlocks = document.querySelectorAll(
		'.wp-block-twh-blocks-table-of-contents'
	);

	tocBlocks.forEach( function ( tocBlock ) {
		// Get all links from both main and nested lists
		const links = tocBlock.querySelectorAll( '.toc-link' );

		links.forEach( function ( link ) {
			const anchor = link.getAttribute( 'data-anchor' );
			const linkText = link.textContent.trim();

			// Find the target heading that matches this link's text
			const allHeadings = document.querySelectorAll( 'h2, h3, h4' );
			let targetHeading = null;

			for ( let heading of allHeadings ) {
				if ( heading.textContent.trim() === linkText ) {
					targetHeading = heading;
					break;
				}
			}

			// Ensure the target heading has the correct ID
			if ( targetHeading && ! targetHeading.id ) {
				targetHeading.id = anchor;
			}

			// Add smooth scroll behavior
			link.addEventListener( 'click', function ( e ) {
				e.preventDefault();
				const target = document.getElementById( anchor );

				if ( target ) {
					// Smooth scroll to the top of the target heading
					target.scrollIntoView( {
						behavior: 'smooth',
						block: 'start',
					} );

					// Update URL without causing a jump
					if ( history.pushState ) {
						history.pushState(
							null,
							null,
							'#' + anchor
						);
					}

					// Focus the heading for accessibility
					target.setAttribute( 'tabindex', '-1' );
					target.focus();
				}
			} );
		} );
	} );
} );